import React from 'react';
import { Col, Row } from '@si-armes/dsfr-react';
import PropTypes from 'prop-types';
import styles from './ModaleInformationArme.module.scss';

const SectionPresentationArme = ({ titre, donnees }) => {
    return (
        <>
            <Row className={styles.sectionTitle}>
                <div className={styles.elementTitle}>{titre}</div>
            </Row>
            <Row>
                {donnees.map((column) => (
                    <Col className={styles.armeDetailsCol}>
                        <Row className={styles.armeDetailsTitle}>{column[0]}</Row>
                        <Row className={styles.armeDetailsInfo}>{column[1]}</Row>
                    </Col>
                ))}
            </Row>
        </>
    );
};

SectionPresentationArme.propTypes = {
    titre: PropTypes.string.isRequired,
    donnees: PropTypes.array.isRequired,
};

export default SectionPresentationArme;
